export default __webpack_public_path__ + "static/media/mconferences3.24e49995.jpg";